<template>
  <div class="oc-subtree" :class="{ 'align-items-center': depth == 0 }">
    <div
      class="oc-node"
      :class="nodeClasses"
      :draggable="diagram.update_access"
      @click="diagram.selectNode(node)"
      @dragstart.stop="diagram.onDragStart($event, node)"
      @dragend.stop="diagram.onDragEnd()"
      @dragover.stop="onDragOver"
      @dragleave.stop="drop_target = false"
      @drop.stop.prevent="onDrop"
    >
      <div v-if="diagram.create_access || diagram.update_access || diagram.delete_access" class="oc-node-actions" @click.stop>
        <v-btn v-if="diagram.create_access" icon x-small color="blue-grey" title="Agregar dependiente" @click="diagram.$emit('addChild', node)"><v-icon small>add</v-icon></v-btn>
        <v-btn v-if="diagram.update_access" icon x-small color="blue" title="Editar" @click="diagram.$emit('editNode', node)"><v-icon small>edit</v-icon></v-btn>
        <v-btn v-if="hasChildren && expanded" icon x-small color="blue-grey" title="Contraer dependientes" @click="diagram.toggle(node)"><v-icon small>expand_less</v-icon></v-btn>
        <v-btn v-if="diagram.delete_access" icon x-small color="red" title="Eliminar" @click="diagram.$emit('deleteNode', node)"><v-icon small>delete_outline</v-icon></v-btn>
      </div>

      <div v-if="node.legajo" class="oc-avatar">{{ initials(node.legajo) }}</div>
      <div v-else class="oc-avatar oc-avatar--vacant" title="Asignar responsable" @click.stop="diagram.update_access && diagram.$emit('assignResponsible', node)">+</div>

      <div class="oc-node-text">
        <div class="oc-node-name" :title="node.name">{{ node.name }}</div>
        <div v-if="node.legajo" class="oc-node-detail">{{ node.legajo.name }} {{ node.legajo.surname }}</div>
        <div v-else class="oc-node-detail oc-vacant-label">Vacante</div>
        <div v-if="isPrimaryType" class="oc-node-detail">{{ node.legajos_count }} {{ node.legajos_count == 1 ? "legajo" : "legajos" }}</div>
        <div v-if="!node.enabled" class="oc-node-detail oc-vacant-label">Inactivo</div>
      </div>
    </div>

    <div v-if="hasChildren && !expanded" class="oc-collapse-toggle" @click="diagram.toggle(node)">
      <v-icon small color="primary">expand_more</v-icon> {{ node.children.length }} {{ node.children.length == 1 ? "dependiente" : "dependientes" }}
    </div>

    <div v-if="hasChildren && expanded" :class="depth == 0 ? 'oc-children-h' : 'oc-children-v'">
      <div v-for="child in node.children" :key="child.id" class="oc-branch">
        <OrgChartNode :node="child" :depth="depth + 1" />
      </div>
    </div>
  </div>
</template>

<script>
import { NODE_STYLE_LIGHT, PRIMARY_NODE_STYLES } from "@/constants/org_chart";

export default {
  name: "OrgChartNode",
  inject: ["diagram"],
  props: {
    node: Object,
    depth: { type: Number, default: 0 },
  },
  data() {
    return {
      drop_target: false,
    };
  },
  computed: {
    hasChildren() {
      return this.node.children && this.node.children.length > 0;
    },
    expanded() {
      return this.diagram.isExpanded(this.node);
    },
    isPrimaryType() {
      return this.node.node_type != null && PRIMARY_NODE_STYLES.includes(this.node.node_type.style);
    },
    nodeClasses() {
      const style = this.node.node_type != null ? this.node.node_type.style : NODE_STYLE_LIGHT;
      return {
        ["oc-node--" + style]: true,
        "oc-node--vacant": this.node.legajo == null,
        "oc-node--disabled": !this.node.enabled,
        "oc-node--dimmed": this.node.matches_filter === false || this.diagram.isDimmedBySearch(this.node),
        "oc-node--match": this.diagram.isSearchMatch(this.node),
        "oc-node--drop-target": this.drop_target,
      };
    },
  },
  methods: {
    initials(legajo) {
      return ((legajo.name || "").charAt(0) + (legajo.surname || "").charAt(0)).toUpperCase();
    },
    onDragOver(e) {
      if (!this.diagram.canDropOn(this.node)) return;
      e.preventDefault();
      this.drop_target = true;
    },
    onDrop() {
      this.drop_target = false;
      this.diagram.onDrop(this.node);
    },
  },
};
</script>
